import React, { useEffect, useState } from 'react'
import { OnAmtList, ProductItemOpt, PurchaseProductList } from '../../../../helpers/models/Models'
import { MasterCategoryOptions, PaymentModeOptions, ProductPurchaseOptions, ProductStoreOptions, ProductSubLedgerOptions, ProductSuppilerOptions, PurchaseStatusOptions, SubCategoryOptions, SubLedgerOptions } from '../../../../constants/Options';
import Container from '../../../../constants/Container';
import { useFormik } from 'formik';
import { postDataToTheServer } from '../../../../helpers/api';
import AppURL from '../../../../constants/AppURL';
import { ToastSuccess, ToastWarning } from '../../../../constants/Toast';
import SecHeading from '../../../../constants/SecHeading';
import { Grid } from '@mui/material';
import SelectInputBox from '../../../../constants/SelectInputBox';
import { handleSelectBox } from '../../../../helpers/handleChange';
import useFetchSubData from '../../../../helpers/useSubFetch';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import DefaultSelectInputBox from '../../../../constants/DefaultSelectBox';
import InputTextBox from '../../../../constants/InputTextBox';
import { PiSquaresFour } from 'react-icons/pi';
import { NepNowDateFormat } from '../../../../constants/DateFormat';
import { useDispatch } from 'react-redux';
import { PURCHASE_PRODUCT_LIST } from '../../../../store/inventorySlice';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { formatMoney } from '../../../../helpers/DateFormat';
import { purchaseDataPost } from '../../../../helpers/submitDataOnServer';
import AmountCalcView from './widgets/AmountCalcView';

interface ProductPurchaseFormViewProps {
  data_opt: ProductItemOpt;
  loading: boolean;
}
const ProductPurchaseFromView: React.FC<ProductPurchaseFormViewProps> = ({ data_opt, loading }) => {
  const categoryMaterOptions = MasterCategoryOptions(data_opt?.master_category);
  const productSuppilerOptions = ProductSuppilerOptions(data_opt?.product_suppiler || []);
  const productStoreOptions = ProductStoreOptions(data_opt?.product_store || []);
  const paymentModeOptions = PaymentModeOptions(data_opt?.payment_mode);
  const subLedgerOptions = ProductSubLedgerOptions(data_opt?.sub_ledger);
  // Assuming your state is something like this:
  const [onAmtList, setOnAmtList] = useState<OnAmtList>({
    total_product_amt: 0,
    final_total_amt: 0,
    vatAmt: 0, // Initialize vatAmt here as well
  });
  const nepDate = NepNowDateFormat();
  const dispatch = useDispatch();
  const initialValues = {
    master_category: "",
    pur_sale_date: nepDate || "",
    product_category: "",
    product: "",
    store: "",
    suppiler: "",
    purchase_status: "",
    payment_mode: 5 || "",
    sglsn: 5 || "",
    purchase_rate: "",
    purchase_qty: "",
    vat_amt: "",
    dis_amt: "",
    dis_per: "",
    pur_tot_amt: "",
    tot_amt: "",
    remarks: "",
  };
  const { PurchaseProductList } = useSelector((state: RootState) => state.inventory);

  const { values, errors, touched, setFieldValue, handleBlur, handleChange, handleSubmit } = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: async (values, action) => {
      const sn = PurchaseProductList.length + 1;
      const newProducts: PurchaseProductList[] = [
        {
          sn,
          master_category: parseInt(values.master_category) || 0,
          pur_sale_date: values.pur_sale_date,
          product_category: parseInt(values.product_category) || 0,
          product: parseInt(values.product) || 0,
          store: values.store || 0,
          suppiler: parseInt(values.suppiler) || 0,
          purchase_status: parseInt(values.purchase_status) || 0,
          payment_mode: values.payment_mode,
          sglsn: values.sglsn || 0,
          purchase_rate: parseFloat(values.purchase_rate || '0'),
          purchase_qty: parseFloat(values.purchase_qty || '0'),
          remarks: values.remarks,
          vat_amt: parseFloat(values.vat_amt || '0'),
          dis_amt: parseFloat(values.dis_amt || '0'),
          dis_per: parseFloat(values.dis_per || '0'),
          tot_amt: formatMoney(onAmtList.final_total_amt),
          pur_tot_amt: onAmtList.final_total_amt
        }
      ];

      try {
        if (onAmtList.final_total_amt > 0) {
          try {
            dispatch(PURCHASE_PRODUCT_LIST(newProducts));
            action.resetForm();
          } catch (error) {
            console.error("Error saving product purchase:", error);
          }
        } else {
          ToastWarning({ message: "Total purchase amount must be greater than 0" });
        }
      } catch (error) {
        console.error("Error saving product purchase:", error);
      }
    },
  });
  const { data: data_category, loading: category_loading, error: category_error } = useFetchSubData(AppURL.InventoryURL + "inventory/product/category/master/wise/list/?product_master=" + values.master_category, values.master_category);
  const subCategoryOptions = SubCategoryOptions(data_category?.sub_category);
  const { data: product_data, loading: product_loading, error: product_error } = useFetchSubData(AppURL.InventoryURL + "inventory/product/options/list/view/?sub_master=" + values.product_category, values.product_category);
  const productOptions = ProductPurchaseOptions(product_data?.products);
  const handleSaveSubmit = async () => {
    await purchaseDataPost(PurchaseProductList, dispatch);
  };
  useEffect(() => {
    const totalProductAmt = parseFloat(values.purchase_rate || "0") * parseFloat(values.purchase_qty || "0");
    const vatAmt = totalProductAmt * parseFloat(values.vat_amt || "0") / 100;
    const totalWithVat = totalProductAmt + vatAmt;
    const totalDisPerc = totalWithVat * parseFloat(values.dis_per || "0") / 100;
    const totalFinalAmt = (totalWithVat - totalDisPerc) - parseFloat(values.dis_amt || "0");
    setOnAmtList({
      total_product_amt: totalProductAmt,
      vatAmt: vatAmt,
      final_total_amt: totalFinalAmt,
    });
  }, [values.purchase_qty, values.purchase_rate, values.vat_amt, values.dis_amt, values.dis_per]);


  return (
    <Container padding={true}>
      <form onSubmit={handleSubmit}>
        <SecHeading type='add' label='Add Purchase Product' />
        <Grid container columnSpacing={3} rowSpacing={0.8}>
          <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
            <SelectInputBox
              label='Master Category'
              options={categoryMaterOptions}
              name='master_category'
              required={true}
              placeholder='Select meter status'
              optionSelect={(name, selectedOption) => {
                handleSelectBox({ setFieldValue, name, value: selectedOption })
              }}
              handleBlur={() => {
                handleBlur({ target: { name: 'master_category' } });
              }}
              value={values.master_category}
              touched={touched.master_category}
              errors={errors.master_category}
            />
          </Grid>
          <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
            <SelectInputBox
              label='Product Category'
              options={subCategoryOptions}
              name='product_category'
              required={true}
              placeholder='Select Product Category'
              optionSelect={(name, selectedOption) => {
                handleSelectBox({ setFieldValue, name, value: selectedOption })
              }}
              handleBlur={() => {
                handleBlur({ target: { name: 'product_category' } });
              }}
              isLoading={category_loading}
              value={values.product_category}
              touched={touched.product_category}
              errors={errors.product_category}
            />
          </Grid>

          <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
            <SelectInputBox
              label='Product'
              options={productOptions}
              name='product'
              required={true}
              placeholder='Select Product'
              optionSelect={(name, selectedOption) => {
                setFieldValue("purchase_qty", '');
                setFieldValue("purchase_rate", selectedOption.pur_rate);
                setFieldValue("vat_amt", selectedOption.vat_perc);
                setFieldValue("dis_amt", selectedOption.disc_amt);
                setFieldValue("dis_per", selectedOption.disc_perc);
                handleSelectBox({ setFieldValue, name, value: selectedOption })
              }}
              handleBlur={() => {
                handleBlur({ target: { name: 'product' } });
              }}
              value={values.product}
              touched={touched.product}
              errors={errors.product}
            />
          </Grid>

          <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
            <InputTextBox
              type='text'
              prefix={<PiSquaresFour />}
              name='purchase_qty'
              label='Purchase Qty'
              handleChange={handleChange}
              value={values.purchase_qty}
              error={errors.purchase_qty}
              handleBlur={handleBlur}
              touched={touched.purchase_qty}
              required={true}
              disabled={!values.product}
              placeholder='0'
            />
          </Grid>

          <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
            <SelectInputBox
              label='Product Suppiler'
              options={productSuppilerOptions}
              name='suppiler'
              required={true}
              placeholder='Select Product Suppiler'
              optionSelect={(name, selectedOption) => {
                handleSelectBox({ setFieldValue, name, value: selectedOption })
              }}
              handleBlur={() => {
                handleBlur({ target: { name: 'suppiler' } });
              }}
              value={values.suppiler}
              touched={touched.suppiler}
              errors={errors.suppiler}
            />
          </Grid>
          <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
            <SelectInputBox
              label='Product Store'
              options={productStoreOptions}
              name='store'
              required={true}
              placeholder='Select Product Store'
              optionSelect={(name, selectedOption) => {
                handleSelectBox({ setFieldValue, name, value: selectedOption })
              }}
              handleBlur={() => {
                handleBlur({ target: { name: 'store' } });
              }}
              value={values.store}
              touched={touched.store}
              errors={errors.store}
            />
          </Grid>
          <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
            <SelectInputBox
              label='Purchase Status'
              options={PurchaseStatusOptions}
              name='purchase_status'
              required={true}
              placeholder='Select Purchase Status'
              optionSelect={(name, selectedOption) => {
                handleSelectBox({ setFieldValue, name, value: selectedOption })
              }}
              handleBlur={() => {
                handleBlur({ target: { name: 'purchase_status' } });
              }}
              value={values.purchase_status}
              touched={touched.purchase_status}
              errors={errors.purchase_status}
            />
          </Grid>
          <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
            <DefaultSelectInputBox
              label='Payment Mode'
              options={paymentModeOptions}
              optionSelect={(name, selectedOption) => {
                setFieldValue('sglsn', '');
                setFieldValue(name, selectedOption.value);
              }}
              required={true}
              placeholder='Select Payment Mode'
              name='payment_mode'
              handleBlur={() => {
                handleBlur({ target: { name: 'payment_mode' } });
              }}
              value={values.payment_mode}
              touched={touched.payment_mode}
              errors={errors.payment_mode}
            />
          </Grid>
          {
            values.payment_mode?.toString() !== "5" &&<Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
              <SelectInputBox
                label='Select Bank'
                options={subLedgerOptions}
                name='sglsn'
                required={values.payment_mode?.toString() === "5" ? false : true}
                placeholder='Select Bank'
                optionSelect={(name, selectedOption) => {
                  handleSelectBox({ setFieldValue, name, value: selectedOption })
                }}
                handleBlur={() => {
                  handleBlur({ target: { name: 'sglsn' } });
                }}
                value={values.sglsn}
                touched={touched.sglsn}
                errors={errors.sglsn}
              />
            </Grid>
          }
          <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
            <InputTextBox
              type='text'
              name='remarks'
              label='Remarks'
              handleChange={handleChange}
              value={values.remarks}
              error={errors.remarks}
              handleBlur={handleBlur}
              touched={touched.remarks}
              required={false}
              placeholder='Enter Remarks'
            />
          </Grid>
          {
            values.product && <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
              <AmountCalcView finalTotalAmt={onAmtList.final_total_amt} disAmt={parseFloat(values.dis_amt)} disPerc={parseFloat(values.dis_per)} vatPerc={parseFloat(values.vat_amt)} totalProductAmt={onAmtList.total_product_amt} />
            </Grid>
          }
          <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
            <EndBaseLine top={18}>
              <Button btn_type='save' onClick={handleSaveSubmit} type='button' el='button' />
              <Button btn_type='add' type='submit' el='button' />
            </EndBaseLine>
          </Grid>
        </Grid>
      </form>

    </Container>
  )
}

export default ProductPurchaseFromView